import { render, staticRenderFns } from "./getKurList.vue?vue&type=template&id=4c49e282&"
import script from "./getKurList.vue?vue&type=script&lang=js&"
export * from "./getKurList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports